<template>
  <v-container fluid style="padding: 0 12px">
    <!--Main filter-->
    <v-card class="pa-0 ma-0 mt-3 mb-5 " elevation="0">
      <v-row align="center" style="position: relative" class="ma-0 pa-0">
        <v-col class="ma-0 pa-0" cols="3">
          <combobox-filter2000
            class="ma-0 pa-0 red--text "
            v-model="bankFilterArray"
            :label="this.$t('cards.banks')"
            :items="banks"
            itemText="bankName"
            itemValue="bankId"
            :prepend-icon="'mdi-bank'"
            style="z-index: 1000"
          />
        </v-col>
        <v-col class="ma-0 pa-0" cols="3">
          <BranchCmbxFilter
            ref="branchFilter"
            v-model="branchFilterArray"
            :bankFilterArray="bankFilterArray"
          />
        </v-col>
        <v-col class="ma-0 pa-0" cols="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="cardStatusesFilterArray"
            :label="this.$t('cards.cardStatuses')"
            :items="cardStatuses"
            itemText="statusName"
            itemValue="cardStatusId"
            :translate="true"
            :localizationFunc="
              (value) => {
                return this.$t('CardStatusNames.' + value.statusName);
              }
            "
            :prepend-icon="'mdi-state-machine'"
            style="z-index: 1000"
            :prependStatuses="true"
            :prependIcon="'mdi-check-all'"
            :prependText="$t('Statuses.SelectAllActiveStatuses')"
            :prependTextSelectAll="$t('Statuses.SelectAll')"
          />
        </v-col>
        <v-col class="ma-0 pa-0" cols="2">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="cardPrioritiesFilterArray"
            :label="this.$t('cards.cardPriorities')"
            :items="cardPriorities"
            itemText="priorityName"
            itemValue="cardPriorityId"
            :prepend-icon="'mdi-clock-outline'"
            style="z-index: 1000"
          />
        </v-col>
        <v-col cols="1" class="my0 py-0">
          <v-row>
            <v-spacer />
            <SearchButtons
              v-on:clear="clearFilter"
              v-on:get="getCards"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <combobox-filter2000
            class="pa-0 ma-0"
            v-model="devicesFilterArray"
            :label="this.$t('cards.devices')"
            :items="devices"
            itemText="deviceName"
            itemValue="deviceName"
            :prepend-icon="'mdi-cash-register'"
            style="z-index: 1000"
          />
        </v-col>
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <combobox-filter2000
            class="pa-0 ma-0"
            v-model="productFilterArray"
            :label="this.$t('cards.products')"
            :items="products"
            itemText="productName"
            itemValue="productId"
            :prepend-icon="'mdi-alpha-p-circle-outline'"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <v-text-field
            :label="this.$t('cards.pan')"
            :value="encPanFilter"
            @change="(v) => (encPanFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (encPanFilter = '')"
            :prepend-icon="'mdi-credit-card-outline'"
          />
        </v-col>
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <v-text-field
            :label="this.$t('cards.cardholder')"
            :append-icon="'mdi-close'"
            :value="cardholderFilter"
            @change="(v) => (cardholderFilter = v)"
            @click:append="() => (this.cardholderFilter = '')"
            :prepend-icon="'mdi-account-circle-outline'"
          />
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <DateFilter
            :label="this.$t('cards.actionDate')"
            :dateBegin="dateActTempBegin"
            :dateEnd="dateActTempEnd"
            v-on:changed="
              (dateActFrom, dateActTo) =>
                this.onActDateChange(dateActFrom, dateActTo)
            "
          />
        </v-col>
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <DateFilter
            :label="this.$t('cards.JobDate')"
            :dateBegin="dateTempBegin"
            :dateEnd="dateTempEnd"
            v-on:changed="
              (dateFrom, dateTo) => this.onDateChange(dateFrom, dateTo)
            "
          />
        </v-col>
        <v-col class="pa-0 ma-0" cols="3" sm="3">
          <v-text-field 
            style="padding-top: 0px"
            :label="this.$t('cards.jobs')"
            :append-icon="'mdi-close'"
            :value="jobNameFilter"
            @change="(v) => (jobNameFilter = v)"
            @click:append="() => (this.jobNameFilter = '')"
            :prepend-icon="'mdi-file-document-outline'"
          />
        </v-col>
      </v-row>
    </v-card>

    <!--Data table-->
    <v-row class="mb-0 pb-0" style="margin-top: -30px !important">
      <v-col class="d-flex mb-0 pb-0 pa-0" cols="12" sm="12">
        <v-container class="mb-0 pb-0 mr-0 pr-0 ml-0 pl-0" fluid>
          <v-card class="pa-0 ma-0" id="cardID">
            <v-card-title class="mb-0 pb-0 mt-0 pt-0">
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0 d-flex align-center" cols="7">
                  <v-tooltip v-if="hasManageRight" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        class="mr-1"
                        small
                        :outlined="cardActionsMode !== 0"
                        color="primary"
                        @click="cardActionsMode = 0"
                        v-on="{ ...tooltip }"
                      >
                        <v-icon>
                          mdi-credit-card-multiple
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("GroupActionsForSelectedCards") }}
                  </v-tooltip>

                  <v-tooltip v-if="hasManageRight" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        small
                        :outlined="cardActionsMode !== 1"
                        color="primary"
                        @click="cardActionsMode = 1"
                        v-on="{ ...tooltip }"
                      >
                        <v-icon>
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("GroupActionsForFilter") }}
                  </v-tooltip>

                  <v-spacer v-if="hasManageRight"></v-spacer>

                  <ManageCardDialog
                    v-if="hasManageRight"
                    :key="manageCardDialogKey"
                    :selected-cards="selected"
                    :filter="filterJson"
                    :mode="cardActionsMode"
                    :buttonIsDisabled="manageCardDialogIsDisabled"
                    v-on:rerender="rerender"
                  />
                  <v-spacer v-if="hasManageRight"></v-spacer>
                  <CardsActionsComponent
                    v-if="hasManageRight"
                    :actionGroup="defaultGroupCardActionsFirst"
                    v-on:executeAction="onCardActionGroup"
                  />
                  <v-spacer v-if="hasManageRight" />
                  <CardsActionsComponent
                    v-if="hasManageRight"
                    :actionGroup="defaultGroupCardActionsSecond"
                    v-on:executeAction="onCardActionGroup"
                  />
                  <v-spacer v-if="hasManageRight"></v-spacer>
                  <div v-if="hasManageRight" class="d-flex">
                    <Confirm
                      v-for="action in prioritiesCardActions"
                      :key="action.id"
                      :buttonIcon="action.icon | addMdi"
                      :dialogTitle="$t('ConfirmAction')"
                      :disabled="
                        cardActionsMode === 0 &&
                          (selected.length === 0 ||
                            statusIsCancel() ||
                            (selected.length === 1 &&
                              selected[0].cardPriorityId == action.id))
                      "
                      :dialogText="$t('CardPriorityActions.' + action.name)"
                      :okText="$t('Continue')"
                      :cancelText="$t('Cancel')"
                      :tooltipText="$t('CardPriorityActions.' + action.name)"
                      v-on:ok="
                        () => {
                          onCardPriorityAction(action.name);
                        }
                      "
                    />
                  </div>

                  <v-spacer v-if="hasManageRight"></v-spacer>

                  <CardLogsDialog
                    v-if="$store.getters.CAN_SEE_LOGS"
                    :disabled="selected.length !== 1"
                    :card="selected[0]"
                  />
                  <v-spacer v-if="$store.getters.HAS_REPORTS"></v-spacer>
                  <PrintCardsDialog
                    :disabled="loadReport"
                    v-on:createReport="onCreateReport"
                  />
                  <v-spacer></v-spacer>
                </v-col>

                <v-col
                  class="pa-0 ma-0 d-flex"
                  style="flex-direction: row; justify-content: flex-end"
                  cols="5"
                >
                  <v-row
                    class="ma-0 pa-0 d-flex"
                    style="flex-direction: row; align-items: center; justify-content: flex-end;"
                  >
                    <v-col cols="4" class="ma-0 pa-0 pr-1">
                      <v-select
                        v-model="intervalTime"
                        :items="intervalTimeValues"
                        :label="this.$t('cards.refresh')"
                      />
                    </v-col>
                    <v-col cols="4" class="ma-0 pa-0 pr-1">
                      <v-select
                        v-on:change="getCards"
                        v-model="limit"
                        :items="limitValues"
                        :label="this.$t('cards.rowsPerPage')"
                        item-text="value"
                        item-value="value"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-title>
            <div>
              <div
                id="HeightGetter1"
                style="height:100%; width:100%"
              ></div>
              <LoadIcon v-if="loading" />
              <v-data-table
                id="dtID"
                ref="dataTable"
                fixed-header
                v-model="selected"
                :headers="headers"
                :items="cards"
                :sort-by.sync="currentSort"
                :sort-desc.sync="currentSortDesc"
                :custom-sort="customSort"
                :single-select="singleSelect"
                :multi-sort="false"
                :disable-pagination="true"
                :disable-sort="false"
                item-key="cardId"
                hide-default-footer
                :loading="loading"
                show-select
                loading-text="Loading... Please wait"
                :height="tableHeight"
              >
                <template v-slot:item.statusName="{ item }">
                  <v-tooltip
                    v-if="
                      item.statusName === 'Error' || item.statusName === 'Pause'
                    "
                    bottom
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <span
                        v-on="{ ...tooltip }"
                        :style="{
                          color: statusToColor(item.statusName),
                          'font-weight': 'bold',
                        }"
                      >
                        {{ $t("CardStatusNames." + item.statusName) }}
                      </span>
                    </template>
                    <div>
                      <p>
                        {{ $t("LastStatus") }}:
                        {{ $t("CardStatusNames." + item.lastStatusName) }}
                      </p>
                      <p v-if="item.statusName === 'Error'">
                        {{ $t("Error") }}: '{{ item.message }}'
                      </p>
                    </div>
                  </v-tooltip>
                  <span
                    v-else
                    :style="{
                      color: statusToColor(item.statusName),
                      'font-weight': 'bold',
                    }"
                  >
                    {{ $t("CardStatusNames." + item.statusName) }}
                  </span>
                </template>
                <template v-slot:item.priorityName="{ item }">
                  {{ item.priorityName }}
                </template>
                <template v-slot:item.deviceName="{ item }">
                  <v-row>
                    <span
                      v-if="item.deviceStatusId === 5"
                      style="color: red; font-weight: bold"
                      >{{ item.deviceName || '' }}</span
                    >
                    <span v-else>{{ item.deviceName || '' }}</span>
                    <v-tooltip v-if="item.deviceStatusId !== 1" bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon
                          :color="item.deviceStatusId === 2 ? 'yellow' : 'red'"
                          dense
                          v-on="{ ...tooltip }"
                          v-if="item.deviceName && item.deviceName.length !== ''"
                        >
                          mdi-alert-circle-outline
                        </v-icon>
                      </template>
                      <div>
                        {{
                          $t(
                            "devicestatusNames.statusName" + item.deviceStatusId
                          )
                        }}
                      </div>
                    </v-tooltip>
                  </v-row>
                </template>
                <template v-slot:item.lastActionDateTime="{ item }">
                  {{ item.lastActionDateTime | formattedDate }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-row align-content="center">
                    <div v-for="action in item.actions" :key="action.id">
                      <Confirm
                        v-if="
                          ($store.getters.ENABLE_CANCEL_CARDS ||
                            action.name !== 'tocancel') &&
                            action.requireConfirmation &&
                            !action.requireInput
                        "
                        :buttonIcon="action.icon | addMdi"
                        :dialogTitle="$t('ConfirmAction')"
                        :dialogText="$t('CardActions.' + action.name)"
                        :okText="$t('Continue')"
                        :cancelText="$t('Cancel')"
                        :tooltipText="$t('CardActions.' + action.name)"
                        v-on:ok="onSingleCardAction(item, action, 'Ошибка')"
                      />
                      <Promt
                        v-else-if="
                          ($store.getters.ENABLE_CANCEL_CARDS ||
                            action.name !== 'tocancel') &&
                            action.requireInput
                        "
                        :buttonIcon="action.icon | addMdi"
                        :dialogTitle="$t('CardActions.' + action.name)"
                        :textLable="$t('CardActions.DialogText.' + action.name)"
                        :okText="$t('Continue')"
                        :cancelText="$t('Cancel')"
                        :tooltipText="$t('CardActions.' + action.name)"
                        @ok="(text) => onSingleCardAction(item, action, text)"
                      />
                      <v-tooltip
                        bottom
                        v-else-if="
                          $store.getters.ENABLE_CANCEL_CARDS ||
                            action.name !== 'tocancel'
                        "
                      >
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            class="mr-1"
                            small
                            color="primary"
                            v-on="{ ...tooltip }"
                            icon
                            @click="
                              () => onSingleCardAction(item, action, '???')
                            "
                          >
                            <v-icon>{{ action.icon | addMdi }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("CardActions." + action.name) }}</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
    <v-row align="start">
      <v-col class="d-flex">
        <v-row style="display: flex; justify-content: center">
          <v-pagination
            v-on:input="getCardsAndStartTimer"
            v-model="page"
            :length="paginationLength"
            :total-visible="totalVisible"
          />
        </v-row>
      </v-col>

      <p class="d-flex v-card__title">
        {{ $t("cards.records") }} {{ $t("from") }} {{ limit * (page - 1) + 1 }}
        {{ $t("to") }} {{ limit * page }}
      </p>
      <p align="right" class="d-flex v-card__title">
        {{ $t("cards.total") }}: {{ totalCount }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
import DateFilter from '../components/FiltersComponent/DateFilter';
import SearchButtons from '@/components/FiltersComponent/SearchButtons';
import CardsActionsComponent from '@/components/CardsComponents/CardsActionsComponent';
import ManageCardDialog from '@/components/ManageCardDialog';
import LoadIcon from '@/components/LoadIcon';
import { notifyError, notifySuccess } from '@/services/notifications';
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import BranchCmbxFilter from '@/components/FiltersComponent/FinishedFilters/BranchCmbxFilter';
import CardLogsDialog from '@/components/Dialogs/CardLogsDialog';
import Confirm from '@/components/Dialogs/Confirm';
import PrintCardsDialog from '@/components/Dialogs/PrintCardsDialog';
import Promt from '@/components/Dialogs/Promt';
import formatDate from '@/services/dateFormatter';
import { NamesDB } from '@/constants/DBNames.js';
import tableHeightMixin from './mixins/tableHeightMixin';

export default {
  name: 'Cards',
  mixins: [tableHeightMixin],
  data() {
    return {
      loadReport: false,

      activeStatuses: ['waiting', 'process', 'pending', 'error', 'pause'],
      waitingCardsResponse: false,

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 64,
      filterH: 180,
      tHeaderH: 70,
      tFooterH: 82,

      manageCardDialogKey: 0,

      // Переменная видимости фильтра
      showFullFilter: false,

      // Необходимо для определения
      cardActionsMode: 0,
      actions: [],

      // Настройки интервала обновления таблицы таблицы
      intervalTime: 30,

      interval: {},

      page: 1,
      limit: 10,
      paginationLength: 100,

      totalCount: '',
      totalVisible: 10,

      selected: [],
      singleSelect: false,

      cards: [],

      currentSortDesc: [],
      currentSort: [],

      cardStatuses: [],
      cardPriorities: [],
      banks: [],
      branches: [],
      devices: [],
      products: [],
      devicesDesigns: [],

      loading: false,
      isMounted: false,

      cardStatusesFilter: 0,
      cardStatusesFilterArray: [],
      cardPrioritiesFilter: 0,
      cardPrioritiesFilterArray: [],
      bankFilter: 0,
      bankFilterArray: [],
      branchFilter: 0,
      branchFilterArray: [],
      productFilterArray: [],
      devicesFilterArray: [],
      jobFilterArray: [],
      jobNameFilter: '',
      panFilter: '',
      encPanFilter: '',
      cardholderFilter: '',
      jobDateFilter: [],
      dateTempBegin: '',
      dateTempEnd: '',
      actDateFilter: [],
      dateActTempBegin: '',
      dateActTempEnd: '',
      lastSort: 'lastActionDateTime',
    };
  },
  filters: {
    addMdi(icon) {
      return 'mdi-' + icon;
    },
    formattedDate(dateString) {
      return formatDate(dateString);
    },
  },
  watch: {
    async currentSortDesc() {
      this.getCards();
    },
    async currentSort(val) {
      if (val.length != 0) {
        this.lastSort = val[0];

        this.getCards();
      }
    },
    async cardActionsMode(val) {
      if (val) {
        await this.getActionsForFilter();
      } else {
        await this.getActionsForSelected();
      }
    },
    async selected() {
      if (!this.cardActionsMode) {
        this.getActionsForSelected();
      }
    },
    bankFilterArray: async function() {
      this.branches = [];
      this.devices = [];
      this.products = [];

      if (!this.bankFilterArray || this.bankFilterArray.length !== 0)
        this.loadDataByBankFilterArray();

      // Сохраняем фильтр банков только если включено в настройках
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBankFilter(this.bankFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
    },
    branchFilterArray: async function() {
      this.checkBankFilter();
      // Сохраняем фильтр отделений только если включено в настройках
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBranchFilter(this.branchFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
      const branchesId = this.branchFilterArray.map((b) => b.branchId);

      if (branchesId.length) {
        await this.$axios.devices
          .getByBranchesArrayForCards(branchesId)
          .then((response) => response.data)
          .then((json) => {
            this.devices = json;
            if (
              this.bankFilterArray != null &&
              this.branchFilterArray.length != 0
            )
              this.devices.unshift(this.withoutDevice);
            this.devicesFilterArray = this.devicesFilterArray.filter((item) =>
              this.hasInArray(item, this.devices, 'deviceId')
            );
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        const banksId = this.bankFilterArray.map((b) => b.bankId);

        this.$axios.devices
          .getByBanksArrayForCards(banksId)
          .then((response) => response.data)
          .then((json) => {
            this.devices = json;
            if (
              this.bankFilterArray != null &&
              this.branchFilterArray.length != 0
            )
              this.devices.unshift(this.withoutDevice);
            this.devicesFilterArray = this.devicesFilterArray.filter((item) =>
              this.hasInArray(item, this.devices, 'deviceId')
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    intervalTime: function() {
      this.$localStorageObj.setIntervalTime(this.intervalTime);
      this.getCardsAndStartTimer();
    },
    limit: function() {
      this.page = 1;
    },
    filterJson() {
      if (this.cardActionsMode) {
        this.getActionsForFilter();
      }
      this.page = 1;
      this.getCardsAndStartTimer();
    },
    cards(val) {
      this.selected = this.selected.filter((item) =>
        this.hasInArray(item, val)
      );
    },
  },
  computed: {
    manageCardDialogIsDisabled() {
      if (this.bankFilterArray.length !== 1) return true;

      if (this.cardActionsMode === 0) {
        return !(
          this.selected.length &&
          this.selected.every((card) => card.statusName === 'Error')
        );
      } else {
        return !(
          this.cardStatusesFilterArray &&
          this.cardStatusesFilterArray.length === 1 &&
          this.cardStatusesFilterArray[0].statusName === 'Error'
        );
      }
    },
    withoutDevice() {
      return {
        deviceId: -1,
        deviceName: this.$t('cards.withoutDevice'),
      };
    },
    hasManageRight() {
      return this.$store.getters.CAN_MANAGE_CARDS;
    },
    pageKey() {
      return this.$route.path;
    },
    intervalTimeValues() {
      return this.$store.getters.UPDATE_FREQUENCY;
    },
    limitValues() {
      var res = this.$store.getters.COUNT_ROWS;

      if (res === undefined || res === null || res.length === 0)
        return [
          { value: 10 },
          { value: 25 },
          { value: 50 },
          { value: 500 },
          { value: 2000 },
          { value: 5000 },
        ];

      return res;
    },
    additionalFiltersVisibility() {
      if (this.showFullFilter) return 'z-index: 3; visibility: visible';

      return 'z-index: 0;  visibility: hidden';
    },
    headers() {
      const sort = true;
      let result = [
        { value: 'numb' },
        { text: this.$t('cards.pan'), value: 'pan', sortable: sort },
        {
          text: this.$t('cards.cardholder'),
          value: 'cardholder',
          sortable: sort,
        },
        { text: this.$t('cards.Status'), value: 'statusName', sortable: sort },
        {
          text: this.$t('cards.Priority'),
          value: 'priorityName',
          sortable: sort,
        },
        {
          text: this.$t('referenceBooks.banks.Bank'),
          value: 'bankName',
          sortable: sort,
        },
        {
          text: this.$t('referenceBooks.branches.Branch'),
          value: 'branchName',
          sortable: sort,
        },
        {
          text: this.$t('referenceBooks.devices.Name'),
          value: 'deviceName',
          sortable: sort,
        },
        {
          text: this.$t('referenceBooks.products.Product'),
          value: 'productName',
          sortable: sort,
        },
        {
          text: this.$t('cards.LastAction'),
          value: 'lastActionDateTime',
          sortable: sort,
        },
        {
          text: this.$t('referenceBooks.Actions'),
          value: 'actions',
          sortable: false,
        },

        { text: this.$t('cards.JobName'), value: 'jobName', sortable: sort },
      ];

      if (this.$store.getters.CARDS_RIGHTS_ON_BANK_LEVEL) {
        result = result.filter((header) => header.value !== 'bankName');
      }
      if (this.$store.getters.CARDS_RIGHTS_ON_BRANCH_LEVEL) {
        result = result.filter((header) => header.value !== 'bankName');
        result = result.filter((header) => header.value !== 'branchName');
      }

      if (!this.hasManageRight) {
        result = result.filter((header) => header.value !== 'actions');
      }

      return result;
    },
    branchesOfBanks() {
      if (this.bankFilterArray.length === 0) return this.branches;

      return this.branches.filter((branch) => {
        return this.bankFilterArray.some(
          (bank) => bank.bankId === branch.bankId
        );
      });
    },
    filterJson() {
      const result = {};

      result.branchesId = this.branchFilterArray.map(
        (branch) => branch.branchId
      );
      result.banksId = this.bankFilterArray.map((bank) => bank.bankId);
      result.cardStatusesId = this.cardStatusesFilterArray.map(
        (status) => status.cardStatusId
      );
      result.cardPrioritiesId = this.cardPrioritiesFilterArray.map(
        (priority) => priority.cardPriorityId
      );
      result.productsId = this.productFilterArray.map(
        (product) => product.productId
      );
      result.devicesId = this.devicesFilterArray.map(
        (device) => device.deviceId
      );
      result.job = !this.jobNameFilter ? '' : this.jobNameFilter;
      result.pan = !this.panFilter ? '' : this.panFilter;
      result.encPan = !this.encPanFilter ? '' : this.encPanFilter;
      result.cardholder = !this.cardholderFilter ? '' : this.cardholderFilter;

      if (this.actDateFilter != null && this.actDateFilter[0] != null)
        result.actionDateFrom = this.actDateFilter[0];
      if (this.actDateFilter != null && this.actDateFilter[1] != null)
        result.actionDateTo = this.actDateFilter[1];

      if (this.jobDateFilter != null && this.jobDateFilter[0] != null)
        result.jobDateFrom = this.jobDateFilter[0];
      if (this.jobDateFilter != null && this.jobDateFilter[1] != null)
        result.jobDateTo = this.jobDateFilter[1];

      return result;
    },
    OrderBy() {
      const Sort = [];

      if (this.currentSort.length == 0) this.restoreSort();

      for (let i = 0; i < this.currentSort.length; i++) {
        Sort.splice(0, 0, {
          Name: NamesDB[this.currentSort[i]],
          SortUp: !this.currentSortDesc[i],
        });
      }

      return { Sort };
    },
    prioritiesCardActions() {
      return [
        {
          id: 1,
          name: 'low',
          icon: 'speedometer-slow',
        },
        {
          id: 2,
          name: 'medium',
          icon: 'speedometer-medium',
        },
        {
          id: 3,
          name: 'high',
          icon: 'speedometer',
        },
      ];
    },
    defaultGroupCardActionsFirst() {
      const actionsArray = [
        {
          name: 'toerror',
          path: '/toerror',
          icon: 'alert-circle-outline',
          requireConfirmation: false,
          requireInput: true,
        },
        {
          name: 'tolast',
          path: '/tolast',
          icon: 'backup-restore',
          requireConfirmation: true,
          requireInput: false,
        },
        {
          name: 'tooperator',
          path: '/tooperator',
          icon: 'account-circle-outline',
          requireConfirmation: true,
          requireInput: false,
        },
        {
          name: 'toprint',
          path: '/toprint',
          icon: 'printer',
          requireConfirmation: true,
          requireInput: false,
        },
      ];

      if (this.$store.getters.ENABLE_TO_FINAL)
        actionsArray.push({
          name: 'tofinal',
          path: '/tofinal',
          icon: 'credit-card-outline',
          requireConfirmation: true,
          requireInput: false,
        });

      if (this.hasManageRight) {
        const tmp = actionsArray.map((action) => {
          const val = this.actions.find(
            (availableAction) => availableAction.name === action.name
          );
          const disabled = val === undefined;
          if (disabled) action.disabled = disabled;
          else {
            action.path = val.path;
            action.disabled = disabled;
          }

          return action;
        });

        return tmp;
      } else {
        return [];
      }
    },
    defaultGroupCardActionsSecond() {
      const actionsArray = [
        {
          name: 'topause',
          path: '/topause',
          icon: 'pause-circle-outline',
          requireConfirmation: true,
          requireInput: false,
        },
      ];

      if (
        this.$store.getters.ENABLE_TO_CENTRAL &&
        this.$store.getters.CAN_SEND_TO_CENTRAL
      ) {
        actionsArray.push({
          name: 'tocentral',
          path: '/tocentral',
          icon: 'bank-outline',
          requireConfirmation: true,
          requireInput: false,
        });

        if (this.$store.getters.ENABLE_TO_CENTRAL_PRINT)
          actionsArray.push({
            name: 'tocentralprint',
            path: '/tocentralprint',
            icon: 'file-export-outline',
            requireConfirmation: true,
            requireInput: false,
          });
      }

      if (this.$store.getters.ENABLE_CANCEL_CARDS)
        actionsArray.push({
          name: 'tocancel',
          path: '/tocancel',
          icon: 'close-circle-outline',
          requireConfirmation: true,
          requireInput: false,
        });

      if (this.$store.getters.ENABLE_CANCEL_CARDS)
        actionsArray.push({
          name: 'tounclaimed',
          path: '/tounclaimed',
          icon: 'credit-card-off-outline',
          requireConfirmation: true,
          requireInput: false,
        });

      if (this.hasManageRight) {
        const tmp = actionsArray.map((action) => {
          const val = this.actions.find(
            (availableAction) => availableAction.name === action.name
          );

          const disabled = val === undefined;

          if (disabled) action.disabled = disabled;
          else {
            action.path = val.path;
            action.disabled = disabled;
          }

          return action;
        });

        return tmp;
      } else {
        return [];
      }
    },
  },
  created() {
    this.$eventBus.$on('langChanged', this.onChangeLang);
  },
  async mounted() {
    this.intervalTime = this.$localStorageObj.getIntervalTime();
    this.setDefaultSort();

    await this.$axios.banks
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.banks = json;
      })
      .catch((error) => {
        console.error(error);
      });

    await this.$axios.cardStatuses
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.cardStatuses = json.filter(
          (status) => status.sortIndex !== -1 && status.cardStatusId !== 20
        );
        this.cardStatuses.forEach((value) => {
          value.newName = this.statusTranslator(value);
        });

        this.SortStatuses();
        this.cardStatusesFilterArray = this.getActiveStatuses();
      })
      .catch((err) => console.error(err));

    await this.$axios.cardPriorities
      .get()
      .then((response) => response.data)
      .then((json) => (this.cardPriorities = json))
      .catch((err) => console.error(err));

    // Загружаем сохранённые фильтры только если включено в настройках
    if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
      const savedBankFilter = this.$localStorageObj.getBankFilter(this.pageKey, this.$store.getters.USERNAME);
      const savedBranchFilter = this.$localStorageObj.getBranchFilter(this.pageKey, this.$store.getters.USERNAME);

      if (savedBankFilter && savedBankFilter.length > 0) {
        const savedBankIds = savedBankFilter.map(b => b.bankId || b);
        this.bankFilterArray = this.banks.filter(bank =>
          savedBankIds.includes(bank.bankId)
        );
      } else if (this.banks.length === 1) {
        this.bankFilterArray.push(this.banks[0]);
      }

      if (this.bankFilterArray.length > 0) {
        await this.loadDataByBankFilterArray();

        if (savedBranchFilter && savedBranchFilter.length > 0) {
          this.$nextTick(() => {
            setTimeout(() => {
              const savedBranchIds = savedBranchFilter.map(b => b.branchId || b);
              if (this.$refs.branchFilter && this.$refs.branchFilter.branches && this.$refs.branchFilter.branches.length > 0) {
                this.branchFilterArray = this.$refs.branchFilter.branches.filter(branch =>
                  savedBranchIds.includes(branch.branchId)
                );
              } else if (this.branches && this.branches.length > 0) {
                this.branchFilterArray = this.branches.filter(branch =>
                  savedBranchIds.includes(branch.branchId)
                );
              }
            }, 800);
          });
        }
      }
    } else if (this.banks.length === 1) {
      this.bankFilterArray.push(this.banks[0]);
      await this.loadDataByBankFilterArray();
    }

    this.isMounted = true;
    await this.getCards();
    this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer();
    this.$eventBus.$off('langChanged');
  },

  methods: {
    onCardActionGroup(action, text) {
      if (this.cardActionsMode) this.onCardActionByFilter(action, text);
      else this.onCardActionBySelected(action, text);
    },
    checkBankFilter() {
      const newBankId = this.getNewFilterBankIdByBranches();

      if (newBankId && newBankId.length > 0)
        this.addNewBanksToFilter(newBankId);
    },
    getNewFilterBankIdByBranches() {
      var res = [];
      const lenBr = this.branchFilterArray.length;
      const lenBank = this.bankFilterArray.length;

      for (var i = 0; i < lenBr; i++) {
        var exist = false;
        const bId = this.branchFilterArray[i].bankId;

        for (var j = 0; !exist && j < lenBank; j++)
          exist = bId === this.bankFilterArray[j].bankId;

        if (!exist && res.find((id) => id === bId) === undefined) res.push(bId);
      }

      return res;
    },
    addNewBanksToFilter(newBanksId) {
      if (!newBanksId || newBanksId.length === 0) return;

      newBanksId.forEach((bankId) =>
        this.bankFilterArray.push(
          this.banks.find((bankVal) => bankVal.bankId === bankId)
        )
      );
    },
    checkBranchFilter() {
      if (!this.bankFilterArray || this.bankFilterArray.length == 0)
        this.branchFilterArray = [];
      else this.filterBracnhFilter();
    },
    filterBracnhFilter() {
      this.branchFilterArray = this.branchFilterArray.filter((val) => {
        var res = false;
        const len = this.bankFilterArray.length;

        for (var i = 0; !res && i < len; i++)
          res = this.bankFilterArray[i].bankId === val.bankId;

        return res;
      });
    },
    async searchBranchesForFilter(val) {
      const params = {
        query: JSON.stringify({ branchName: !val ? '' : val }),
        limit: 10,
        offset: 0,
      };

      let res;

      await this.$axios.branches
        .get(params)
        .then((response) => response.data)
        .then((json) => (res = json.slice(0, 10)));

      return res;
    },

    loadDataByBankFilterArray() {
      const banksId = this.bankFilterArray.map((b) => b.bankId);

      this.$axios.devices
        .getByBanksArrayForCards(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.devices = json;
          if (
            this.bankFilterArray != null &&
            this.branchFilterArray.length != 0
          )
            this.devices.unshift(this.withoutDevice);
          this.devicesFilterArray = this.devicesFilterArray.filter((item) =>
            this.hasInArray(item, this.devices, 'deviceId')
          );
        })
        .catch((error) => {
          console.error(error);
        });

      this.$axios.products
        .getByBanksArrayForCards(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.products = json;
          this.productFilterArray = this.productFilterArray.filter((item) =>
            this.hasInArray(item, this.products, 'productId')
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onChangeLang() {
      this.SortStatuses();
    },
    SortStatuses() {
      this.cardStatuses.forEach((value) => {
        value.newName = this.statusTranslator(value);
      });

      this.cardStatuses.sort(function(a, b) {
        if (a.sortIndex > b.sortIndex) return 1;

        if (a.sortIndex < b.sortIndex) return -1;

        if (a.newName > b.newName) return 1;

        if (a.newName < b.newName) return -1;

        return 0;
      });
    },
    statusTranslator(value) {
      return this.$t('CardStatusNames.' + value.statusName);
    },
    setDefaultSort() {
      this.currentSort.splice(0, 0, 'lastActionDateTime');
      this.currentSortDesc.splice(0, 0, true);
    },
    restoreSort() {
      this.currentSort.splice(0, 0, this.lastSort);
      this.currentSortDesc.splice(0, 0, false);
    },
    statusIsCancel() {
      let res = false;

      this.selected.forEach((val) => {
        res = res || val.cardStatusId === 18;
      });

      return res;
    },
    getActiveStatuses() {
      const activeStatusesList = this.cardStatuses.filter((item) =>
        this.activeStatuses.some((statusName) =>
          item.statusName.toLowerCase().includes(statusName)
        )
      );

      return activeStatusesList;
    },
    compareValues(key, order = 'asc') {
      return function innerSort(a, b) {
        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }

        return order === 'desc' ? comparison * -1 : comparison;
      };
    },
    clearFilter() {
      if (this.banks.length !== 1) {
        this.bankFilterArray = [];
        if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
          this.$localStorageObj.setBankFilter([], this.pageKey, this.$store.getters.USERNAME);
        }
      }
      if (this.branches.length !== 1) {
        this.branchFilterArray = [];
        if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
          this.$localStorageObj.setBranchFilter([], this.pageKey, this.$store.getters.USERNAME);
        }
      }
      this.cardStatusesFilterArray = [];
      this.cardPrioritiesFilterArray = [];
      this.productFilterArray = [];
      this.devicesFilterArray = [];
      this.panFilter = '';
      this.encPanFilter = '';
      this.cardholderFilter = '';
      this.jobNameFilter = '';

      this.actDateFilter = [];
      this.dateActTempBegin = '';
      this.dateActTempEnd = '';

      this.jobDateFilter = [];
      this.dateTempBegin = '';
      this.dateTempEnd = '';
    },
    statusToColor(statusName) {
      switch (statusName) {
      case 'Start':
      case 'PrepWaiting':
      case 'PrepProcess':
      case 'PinWaiting':
      case 'PinProcess':
      case 'PrintWaiting':
      case 'PrintProcess':
      case 'ReportWaiting':
      case 'ReportProcess':
      case 'OperatorPrintPending':
      case 'AdminPrintPending':
      case 'CardDispensing':
        return 'orange';
      case 'Error':
        return 'red';
      case 'Complete':
        return 'green';
      case 'Central':
      case 'CentralComplete':
      case 'Cancel':
        return 'blue';
      default:
        return 'gray';
      }
    },
    async getActions(mode) {
      if (!this.hasManageRight) {
        return;
      }
      this.actions = [];
      let data = {};
      let params = {};

      if (mode) {
        params = {
          query: JSON.stringify(this.filterJson),
          mode: 2,
        };
        data = [];
      } else {
        params = {
          mode: 1,
        };
        data = this.selected.map((card) => card.cardId);
      }

      await this.$axios.cardActions
        .get(data, params)
        .then((response) => response.data)
        .then((json) => (this.actions = json.actions))
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
    },
    async getActionsForFilter() {
      await this.getActions(true);
    },
    async getActionsForSelected() {
      await this.getActions(false);
    },
    hasInArray(item, array, property = 'cardId') {
      return array.some((arrayItem) => arrayItem[property] === item[property]);
    },
    unmarkUnactualSelected() {
      this.selected = this.selected.filter((item) =>
        this.hasInArray(item, this.cards)
      );
    },

    async onCardPriorityAction(actionName) {
      const cardsId = this.selected.map((card) => card.cardId);
      const data = cardsId;

      let mode = 0;
      if (this.cardActionsMode === 0) {
        mode = 1;
      } else {
        mode = 2;
      }
      let priority = 0;
      switch (actionName) {
      case 'high':
        priority = 3;
        break;
      case 'medium':
        priority = 2;
        break;
      case 'low':
        priority = 1;
        break;
      }
      const params = {
        query: JSON.stringify(this.filterJson),
        mode: mode,
        priority: priority,
      };

      await this.$axios.cards
        .changePriorities(data, params)
        .then(() => {
          notifySuccess(
            '',
            this.$t('CardPriorityActions.success' + actionName)
          );
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });

      await this.getCardsAndStartTimer();
    },
    async onCardActionBySelected(action, promptText) {
      const params = {
        mode: 1,
        query: JSON.stringify(this.filterJson),
      };

      const cardsId = this.selected.map((card) => card.cardId);

      const data = {
        cardsId: cardsId,
        error: promptText,
      };
      await this.$axios.cards
        .doCardAction(action.path, data, params)
        .then(async () => {
          notifySuccess('', this.$t('cards.Success'));
          await this.getCardsAndStartTimer();
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
    },
    async onCardActionByFilter(action, promptText) {
      const params = {
        mode: 2,
        query: JSON.stringify(this.filterJson),
      };

      const data = {
        cardsId: [],
        error: promptText,
      };
      await this.$axios.cards
        .doCardAction(action.path, data, params)
        .then(async () => {
          notifySuccess('', this.$t('cards.Success'));
          await this.getCardsAndStartTimer();
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
      await this.getActionsForFilter();
    },

    onSingleCardAction(card, action, promptText) {
      const params = {
        mode: 1,
        query: JSON.stringify(this.filterJson),
      };
      const data = {
        cardsId: [card.cardId],
        error: promptText,
      };
      this.$axios.cards
        .doCardAction(action.path, data, params)
        .then(() => {
          notifySuccess('', this.$t('cards.Success'));
          this.getCards();
        })
        .catch((error) => {
          console.error(error);

          notifyError('', this.$t('Error'));
        });
    },
    getCardsAndStartTimer(filter = undefined) {
      this.stopTimer();
      window.setTimeout(
        async function() {
          if (!this.waitingCardsResponse) {
            this.waitingCardsResponse = true;
            await this.getCards(filter);
            this.waitingCardsResponse = false;
          }
        }.bind(this),
        0
      );
      this.startTimer();
    },

    rerender() {
      this.manageCardDialogKey++;
      this.getCardsAndStartTimer();
    },
    stopTimer() {
      this.waitingCardsResponse = false;
      if (this.interval) {
        window.clearInterval(this.interval);
      }
    },
    startTimer() {
      this.stopTimer();
      this.interval = window.setInterval(
        async function() {
          if (!this.waitingCardsResponse) {
            this.waitingCardsResponse = true;
            await this.getCards();
            this.waitingCardsResponse = false;
          }
        }.bind(this),
        this.intervalTime * 1000
      );
    },
    customSort: function(items) {
      return items;
    },
    async getCards() {
      if (this.loading) return;
      this.loading = true;

      const page = this.page;
      let flag = false;
      const orderBy = this.OrderBy;
      try {
        const params = {
          limit: this.limit,
          offset: this.limit * (this.page - 1),
          query: JSON.stringify(this.filterJson),
        };

        if (orderBy.Sort != undefined && orderBy.Sort != null)
          params.orderby = JSON.stringify(orderBy);

        this.$axios.cards
          .get(params)
          .then((response) => response.data)
          .then((json) => {
            if (this.page == page) {
              let i = 1;

              json.cards.forEach((val) => (val.numb = i++));

              this.cards = json.cards;
            } else flag = true;

            this.loading = false;
          });

        this.$axios.cards
          .getCount(params)
          .then((response) => response.data)
          .then((json) => {
            this.totalCount = json.totalCount;
            this.paginationLength = Math.ceil(json.totalCount / this.limit);
          });
      } catch (error) {
        console.error(error);
        
        this.loading = false;
      }
      if (flag) this.getCards();
    },
    async refreshCards() {
      this.eager = !this.eager;
      await this.getCards();
    },
    onActDateChange(dateFrom, dateTo) {
      this.actDateFilter = [];
      this.actDateFilter.push(dateFrom);
      this.actDateFilter.push(dateTo);

      this.dateActTempBegin = dateFrom;
      this.dateActTempEnd = dateTo;
    },
    onDateChange(dateFrom, dateTo) {
      this.jobDateFilter = [];
      this.jobDateFilter.push(dateFrom);
      this.jobDateFilter.push(dateTo);

      this.dateTempBegin = dateFrom;
      this.dateTempEnd = dateTo;
    },
    onCreateReport(repInfo) {
      this.loadReport = true;

      const params = this.getReportParams(repInfo);

      const FileDownload = require('js-file-download');
      this.$axios.reports
        .get(params)
        .then((response) => {
          FileDownload(response.data, `report_${this.getDateNow()}.xlsx`);
          this.loadReport = false;
        })
        .catch((e) => {
          console.error(e);
          notifyError(e, this.$t('Error'));
          this.loadReport = false;
        });
    },
    getDateNow() {
      const date = new Date();
      var year = date.getFullYear();
      var month = this.padStart(date.getMonth());
      var day = this.padStart(date.getDate());
      var hours = this.padStart(date.getHours());
      var minutes = this.padStart(date.getMinutes());
      var seconds = this.padStart(date.getSeconds());

      return `${year}.${month}.${day}_${hours}-${minutes}-${seconds}`;
    },
    padStart(val, count = 2, char = '0') {
      return val.toString().padStart(count, char);
    },
    getReportParams(repInfo) {
      const orderBy = this.OrderBy;

      const params = {
        countCards: this.limit * repInfo.pageCount,
        offsetCountCards: 1, //this.limit * (this.page - 1),
        query: JSON.stringify(this.filterJson),
      };

      if (orderBy.Sort != undefined && orderBy.Sort != null)
        params.orderby = JSON.stringify(orderBy);

      return params;
    },
  },
  components: {
    Confirm,
    Promt,
    CardLogsDialog,
    ComboboxFilter2000,
    DateFilter,
    LoadIcon,
    SearchButtons,
    BranchCmbxFilter,
    CardsActionsComponent,
    ManageCardDialog,
    PrintCardsDialog,
  },
};
</script>
